// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"0555f562","418":"3106b09d","632":"97d71d67","662":"f1770f91"}[chunkId] + ".chunk.js";
};